import { useContext } from 'react';
import { useStore } from 'zustand';

import { BaleAnalysisContext, EvidenceAnalysisContext } from '../../components/BaleAnalysisContext/BaleAnalysisContext';
/**
 * @deprecated
 */
export const useBaleAnalysisStore = () => {
  const store = useContext(BaleAnalysisContext);
  if (!store) {
    throw new Error('Missing BaleAnalysisProvider');
  }
  return useStore(store);
};

export const useEvidenceAnalysisStore = () => {
  const store = useContext(EvidenceAnalysisContext);
  if (!store) {
    throw new Error('Missing EvidenceAnalysisProvider');
  }
  return useStore(store);
};
